<div class="order-success-page">
  <main class="success-main">
    <div class="success-content">
      <div class="success-icon-container">
        <div class="success-icon">
          <span class="mdn-Icon-check mdn-Icon--lg" [attr.aria-label]="'pages.orderSuccess.iconAlt' | i18n"></span>
        </div>
      </div>

      <h1 class="success-title">{{ titleKey | i18n }}</h1>

      <div class="success-message">
        <p>{{ message1Key | i18n }}</p>
        <p [innerHTML]="message2Key | i18n"></p>
      </div>

      <div class="action-buttons">
        <ustore-button
          [text]="primaryButtonKey | i18n"
          [format]="'filled'"
          [backgroundColor]="'var(--color-red-500-to-yellow)'"
          [textColor]="'#ffffff'"
          [size]="'medium'"
          [rounded]="'default'"
          (click)="goToPrimaryAction()"
          class="primary-button">
        </ustore-button>

        <ustore-button
          [text]="secondaryButtonKey | i18n"
          [format]="'outlined'"
          [backgroundColor]="'var(--color-red-500-to-yellow)'"
          [textColor]="'var(--color-inverted)'"
          [size]="'medium'"
          [rounded]="'default'"
          (click)="goToSecondaryAction()"
          class="secondary-button">
        </ustore-button>
      </div>
    </div>
  </main>
</div>
